/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";

import Spinner from "../components/spinner/Spinner";
import {
  fetchCustomers,
  fetchTenantCustomers,
} from "../scenes/customers/customers.slice";
import { isLoaded as isCustomerListLoaded } from "../scenes/customers/customers.selectors";
import {
  isLoaded as isShopsListLoaded,
  getSelectedShopId,
  getIsShopsError,
  getShops,
} from "../scenes/shops/shops.selectors";
import {
  fetchShops,
  fetchTenantShops,
  fetchShopDevices,
} from "../scenes/shops/shops.slice";
import { getAdminStatus, logoutUser } from "./ui.slice";
import { getRoutePrefix } from "../services/env.service";
import { fetchTenants } from "../scenes/tenants/tenants.slice";
import {
  getSelectedTenant,
  getIsTenantsError,
} from "../scenes/tenants/tenants.selectors";
import { getFromLocalStorage } from "../utils";
import { handleRouting } from "../services/routing.service";

export default function AppLoader({ children }) {
  const isCustomersLoaded = useSelector(isCustomerListLoaded);
  const isShopsLoaded = useSelector(isShopsListLoaded);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const selectedShopId = useSelector(getSelectedShopId);
  const isAdmin = useSelector(getAdminStatus);
  const selectedTenant = useSelector(getSelectedTenant);
  const isShopsError = useSelector(getIsShopsError);
  const isTenantsError = useSelector(getIsTenantsError);
  const shops = useSelector(getShops);

  useEffect(() => {
    const shopId = getFromLocalStorage("selectedShop");

    if (isAdmin) {
      dispatch(fetchTenants());
    } else {
      dispatch(fetchShops({ URLShopId: getRoutePrefix() }));

      if (getRoutePrefix() === shopId) return;

      // vinChange message is sent from Extension to display vehicle with vincode if found
      if (window.self !== window.top) {
        const handleVinChange = (e) => {
          if (e.data.type === "vinChange") {
            const shopId = getFromLocalStorage("shopId");
            history.push(`/${shopId}/vin/${e.data.vin}`);
          }
        };
        window.addEventListener("message", handleVinChange);
      }
    }
  }, []);

  useEffect(() => {
    if (selectedTenant && isAdmin) {
      dispatch(
        fetchTenantShops({
          URLShopId: getRoutePrefix(),
          selectedTenantId: selectedTenant.id,
        })
      );
    }
  }, [selectedTenant]);

  useEffect(() => {
    if (selectedShopId) {
      dispatch(fetchShopDevices());
      if (selectedShopId === "tenant") {
        dispatch(fetchTenantCustomers(shops));
      } else {
        dispatch(fetchCustomers());
      }

      if (isAdmin && location.pathname === "/admin") return;

      if (location.pathname === "/" || !getRoutePrefix()) {
        history.push(`/${selectedShopId}/dashboard`);
      }

      if (getRoutePrefix() !== selectedShopId) {
        handleRouting(selectedShopId, history, location.pathname);
      }
    }
  }, [selectedShopId]);

  useEffect(() => {
    if (isShopsError || isTenantsError) dispatch(logoutUser());
  }, [isShopsError, isTenantsError]);

  return isCustomersLoaded && isShopsLoaded ? (
    <> {children}</>
  ) : (
    <div className="main-spinner">
      <Spinner />
    </div>
  );
}
